import { Link } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import CompanyAddress from './CompanyAddress';
import {
  COMPANY_EMAIL,
  COMPANY_NAME,
  EMAIL,
  PHONE,
  SITE_DOMAIN,
  SITE_NAME,
  SITE_URL,
} from '../constants/site';

export default function PolicyLayout({ title, lastUpdated, children }) {
  return (
    <>
      <Header />
      <section className="page-banner page-banner--compact">
        <div className="container">
          <p className="policy-breadcrumb">
            <Link to="/flight">Home</Link> / {title}
          </p>
          <h1 className="policy-page__title">{title}</h1>
          {lastUpdated && <p className="policy-page__updated">Last updated: {lastUpdated}</p>}
        </div>
      </section>
      <article className="container policy-page">
        <div className="policy-page__body">{children}</div>
      </article>
      <Footer />
    </>
  );
}

export function PolicySection({ title, children }) {
  return (
    <section className="policy-section">
      <h2>{title}</h2>
      {children}
    </section>
  );
}

export function PolicyList({ items }) {
  return (
    <ul className="policy-list">
      {items.map((item) => (
        <li key={item}>{item}</li>
      ))}
    </ul>
  );
}

export function PolicySubsection({ title, children }) {
  return (
    <div className="policy-subsection">
      {title && <h3>{title}</h3>}
      {children}
    </div>
  );
}

export function PolicyContact() {
  const tel = PHONE.replace(/[^\d+]/g, '');

  return (
    <div className="policy-contact">
      <p>
        <strong>{COMPANY_NAME}</strong> (operator of {SITE_NAME} / {SITE_DOMAIN})
      </p>
      <p>
        Website: <a href={SITE_URL}>{SITE_URL}</a>
        <br />
        Registered address:
        <br />
        <CompanyAddress as="span" className="policy-contact__address" />
      </p>
      <p>
        Legal &amp; privacy inquiries: <a href={`mailto:${COMPANY_EMAIL}`}>{COMPANY_EMAIL}</a>
        <br />
        Customer support (24/7): <a href={`mailto:${EMAIL}`}>{EMAIL}</a> ·{' '}
        <a href={`tel:${tel}`}>{PHONE}</a>
      </p>
    </div>
  );
}
